if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.recipientFieldsLiveRegion = this.querySelector(`#Recipient-fields-live-region-${this.dataset.sectionId}`);
        this.checkboxInput = this.querySelector(`#Recipient-checkbox-${this.dataset.sectionId}`);
        this.checkboxInput.disabled = false;
        this.hiddenControlField = this.querySelector(`#Recipient-control-${this.dataset.sectionId}`);
        this.hiddenControlField.disabled = true;
        this.emailInput = this.querySelector(`#Recipient-email-${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient-name-${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient-message-${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient-send-on-${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient-timezone-offset-${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.errorMessageWrapper = this.querySelector('.product-form__recipient-error-message-wrapper');
        this.errorMessageList = this.errorMessageWrapper?.querySelector('ul');
        this.errorMessage = this.errorMessageWrapper?.querySelector('.error-message');
        this.defaultErrorHeader = this.errorMessage?.innerText;
        this.currentProductVariantId = this.dataset.productVariantId;
        this.addEventListener('change', this.onChange.bind(this));
        this.onChange();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;
      cartErrorUnsubscriber = undefined;

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.resetRecipientForm();
          }
        });

        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          if (event.data.sectionId === this.dataset.sectionId) {
            this.currentProductVariantId = event.data.variant.id.toString();
          }
        });

        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
          if (event.source === 'product-form' && event.productVariantId.toString() === this.currentProductVariantId) {
            this.displayErrorMessage(event.message, event.errors);
          }
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }

        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }

        if (this.cartErrorUnsubscriber) {
          this.cartErrorUnsubscriber();
        }
      }

      onChange() {
        if (this.checkboxInput.checked) {
          this.enableInputFields();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormExpanded;
        } else {
          this.clearInputFields();
          this.disableInputFields();
          this.clearErrorMessage();
          this.recipientFieldsLiveRegion.innerText = window.accessibilityStrings.recipientFormCollapsed;
        }
      }

      inputFields() {
        return [this.emailInput, this.nameInput, this.messageInput, this.sendonInput];
      }

      disableableFields() {
        return [...this.inputFields(), this.offsetProperty];
      }

      clearInputFields() {
        this.inputFields().forEach((field) => (field.value = ''));
      }

      enableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = false));
      }

      disableInputFields() {
        this.disableableFields().forEach((field) => (field.disabled = true));
      }

      displayErrorMessage(title, body) {
        this.clearErrorMessage();
        this.errorMessageWrapper.hidden = false;
        if (typeof body === 'object') {
          this.errorMessage.innerText = this.defaultErrorHeader;
          return Object.entries(body).forEach(([key, value]) => {
            const errorMessageId = `RecipientForm-${key}-error-${this.dataset.sectionId}`;
            const fieldSelector = `#Recipient-${key}-${this.dataset.sectionId}`;
            const message = `${value.join(', ')}`;
            const errorMessageElement = this.querySelector(`#${errorMessageId}`);
            const errorTextElement = errorMessageElement?.querySelector('.error-message');
            if (!errorTextElement) return;

            if (this.errorMessageList) {
              this.errorMessageList.appendChild(this.createErrorListItem(fieldSelector, message));
            }

            errorTextElement.innerText = `${message}.`;
            errorMessageElement.classList.remove('hidden');

            const inputElement = this[`${key}Input`];
            if (!inputElement) return;

            inputElement.setAttribute('aria-invalid', true);
            inputElement.setAttribute('aria-describedby', errorMessageId);
          });
        }

        this.errorMessage.innerText = body;
      }

      createErrorListItem(target, message) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.setAttribute('href', target);
        a.innerText = message;
        li.appendChild(a);
        li.className = 'error-message';
        return li;
      }

      clearErrorMessage() {
        this.errorMessageWrapper.hidden = true;

        if (this.errorMessageList) this.errorMessageList.innerHTML = '';

        this.querySelectorAll('.recipient-fields .form__message').forEach((field) => {
          field.classList.add('hidden');
          const textField = field.querySelector('.error-message');
          if (textField) textField.innerText = '';
        });

        [this.emailInput, this.messageInput, this.nameInput, this.sendonInput].forEach((inputElement) => {
          inputElement.setAttribute('aria-invalid', false);
          inputElement.removeAttribute('aria-describedby');
        });
      }

      resetRecipientForm() {
        if (this.checkboxInput.checked) {
          this.checkboxInput.checked = false;
          this.clearInputFields();
          this.clearErrorMessage();
        }
      }
    }
  );
// const sendNow = document.getElementById('send-now');
// const sendLater = document.getElementById('send-later');
// const sendLaterField = document.getElementById('send-later-field');
// const forme = document.getElementById('for-me');
// const sendother = document.getElementById('for-someone-else');
// const recipientField = document.getElementById('recipient-fields-wrapper');

// // Function to update UI according to checked states
// function updateUI() {
//   if (sendother.checked) {
//   const mainparent = sendother.closest("form");
//   console.log("main parent:", mainparent);
// }


//   // Handle send now/later
//   if (sendNow.checked) {
//     sendLaterField.classList.add('hidden');
//   } else if (sendLater.checked) {
//     sendLaterField.classList.remove('hidden');
//   }

//   // Handle for me / someone else
//   if (forme.checked) {
//     recipientField.classList.add('hidden');
//   } else if (sendother.checked) {
//     recipientField.classList.remove('hidden');
//   }
// }

// // Attach listeners
// sendNow.addEventListener('change', updateUI);
// sendLater.addEventListener('change', updateUI);
// forme.addEventListener('change', updateUI);
// sendother.addEventListener('change', updateUI);

// // Run once on load
// updateUI();

const sendNow = document.getElementById('send-now');
const sendLater = document.getElementById('send-later');
const sendLaterField = document.getElementById('send-later-field');
const forme = document.getElementById('for-me');
const sendother = document.getElementById('for-someone-else');
const recipientField = document.getElementById('recipient-fields-wrapper');

const recipientName = document.getElementById('Recipient-name-template--19497974071452__main');
const recipientEmail = document.getElementById('Recipient-email-template--19497974071452__main');
const submitBtn = document.getElementById('ProductSubmitButton-template--19497974071452__main');

// Select existing Shopify error divs
const nameErrorDiv = document.getElementById('RecipientForm-name-error-template--19497974071452__main');
const emailErrorDiv = document.getElementById('RecipientForm-email-error-template--19497974071452__main');

// Email validation regex
function isValidEmail(email) {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

// Check recipient fields and toggle submit
function checkRecipientFields() {
  if (sendother.checked) {
    const nameValid = recipientName.value.trim() !== '';
    const emailValid = recipientEmail.value.trim() !== '' && isValidEmail(recipientEmail.value.trim());

    submitBtn.disabled = !(nameValid && emailValid);
  } else {
    submitBtn.disabled = false;
  }
}

// Show error on blur
function validateFieldOnBlur(input, type) {
  if (!sendother.checked) return;

  if (type === 'name') {
    if (!recipientName.value.trim()) {
      nameErrorDiv.classList.remove('hidden');
      nameErrorDiv.querySelector('.error-message').textContent = 'Please enter the name of the recipient.';
    } else {
      nameErrorDiv.classList.add('hidden');
      nameErrorDiv.querySelector('.error-message').textContent = '';
    }
  }

  if (type === 'email') {
    const value = recipientEmail.value.trim();
    if (!value) {
      emailErrorDiv.classList.remove('hidden');
      emailErrorDiv.querySelector('.error-message').textContent = 'Please enter a valid email address.';
    } else if (!isValidEmail(value)) {
      emailErrorDiv.classList.remove('hidden');
      emailErrorDiv.querySelector('.error-message').textContent = 'Please enter a valid email address.';
    } else {
      emailErrorDiv.classList.add('hidden');
      emailErrorDiv.querySelector('.error-message').textContent = '';
    }
  }
}

// Hide error on focus
function clearErrorOnFocus(input) {
  if (!sendother.checked) return;

  if (input === recipientName) {
    nameErrorDiv.classList.add('hidden');
    nameErrorDiv.querySelector('.error-message').textContent = '';
  }
  if (input === recipientEmail) {
    emailErrorDiv.classList.add('hidden');
    emailErrorDiv.querySelector('.error-message').textContent = '';
  }
}

// Update UI function
function updateUI() {
  // Send now/later toggle
  if (sendNow.checked) {
    sendLaterField.classList.add('hidden');
  } else if (sendLater.checked) {
    sendLaterField.classList.remove('hidden');
  }

  // For me / someone else toggle
  if (forme.checked) {
    recipientField.classList.add('hidden');
  } else if (sendother.checked) {
    recipientField.classList.remove('hidden');
  }

  // Check recipient fields for submit button
  checkRecipientFields();
}

// Attach listeners
sendNow.addEventListener('change', updateUI);
sendLater.addEventListener('change', updateUI);
forme.addEventListener('change', updateUI);
sendother.addEventListener('change', updateUI);

// Recipient field listeners
recipientName.addEventListener('input', checkRecipientFields);
recipientEmail.addEventListener('input', checkRecipientFields);

recipientName.addEventListener('blur', () => validateFieldOnBlur(recipientName, 'name'));
recipientEmail.addEventListener('blur', () => validateFieldOnBlur(recipientEmail, 'email'));

recipientName.addEventListener('focus', () => clearErrorOnFocus(recipientName));
recipientEmail.addEventListener('focus', () => clearErrorOnFocus(recipientEmail));

// Initial load
updateUI();


}
